export const isTest = false;

export const defaultAvatar = `${import.meta.env.BASE_URL}img/user/default-avatar.png`;


export const anchorDefaultAvatar = `${import.meta.env.BASE_URL}img/user/anchor-default-avatar.png`;

export const liveGoodsOnTableImg = `${import.meta.env.BASE_URL}img/live/goods-on-table.png`

export const liveTableImg = `${import.meta.env.BASE_URL}img/live/table.png`

export const liveFloatIcon = `${import.meta.env.BASE_URL}img/live/float-icon.png`

export const goodsDefaultImg = `${import.meta.env.BASE_URL}img/goods/goods-default-img.png`